import ModulesStateBasic from 'kts-scaffold-framework/modules/ModulesStateBasic';

/** 模块状态 */
export default class ModulesState extends ModulesStateBasic {
    // 公司风采
    showEleganceModal: boolean = false;
    imgUrlElegance: string = '';
    imgList: Array<any> = [];

    editDetail: false;
    editBank: false;
    editDescription: false;
    companyInfo: any;
    openingBankInfos: any[];
    uploadTokenData: any;
    countryInfo: any;
    countryStateCities: any;
    countryStates: any;
    updateLogPercent: number = 0;
    updateLogPercentView: boolean = false;
    snapCountry: string;
    snapState: string;
    snapStateCity: string;
    description: string = '';
    activeKey: string = '/workbench/platform/companyinfo';
}


// WEBPACK FOOTER //
// ./src/display/platform/CompanyInfo/Modules.State.ts